type TagName = keyof JSX.IntrinsicElements
/**
 * @description 文字列を指定されたタグで分割する
 * @param {string} inputText  分割対象の文字列
 * @param {keyof JSX.IntrisicElements} tagName HTMLのタグ名
 * @returns { {type: "html" | "string", text: string }[] } 分割後の配列 指定のHTML要素であればtype="html"、そうでないならtype="string"で示される
 */
export const useSplitText = (
  inputText: string,
  tagName: TagName
): ({ type: 'string'; text: string } | { type: 'html'; text: string })[] => {
  const pattern = new RegExp(`(<${tagName}[\\s\\S]*?<\\/${tagName}>)`, 'gi')
  const splitStr = inputText.split(pattern)
  const result = splitStr.map(text => {
    return {
      type: text.match(new RegExp(`^<${tagName}`, 'i'))
        ? ('html' as const)
        : ('string' as const),
      text,
    }
  })
  return result
}
